<template>
  <div class="chords">
    <header class="current-chords">
      <b>Current Chords</b>
      <label>Show Chord Bass<input type="checkbox" v-model="showBass" @change="updateConfig"></label>
    </header>
    <ChordSymbol v-for="chord of chords"
                 :chord="chord"
                 :key="chord.uuid"
                 :config="{showBass: showBass, showVoicing: false}"
                 :uuid="chord.uuid"
                 @update_selection="onUpdateSelection"
    />
  </div>
</template>

<script>
import ChordSymbol from '@/components/ChordSymbol'

export default {
  name: 'CurrentChords',
  components: {
    ChordSymbol
  },
  emits: [
    'input_chord'
  ],
  props: {
    chords: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showBass: true
    }
  },
  methods: {
    updateConfig () {
      this.$emit('update_config', { useBass: this.showBass })
    },
    onUpdateSelection (e) {
      console.log('from symbol', e)
      const index = this.chords.findIndex(c => c.uuid === e.uuid)
      console.log('index', index)
      this.$emit('input_chord', { chord: this.chords[index] })
    }
  }
}
</script>

<style scoped>
.chords {
  display: flex;
  flex-direction: column;
  height: 250px;
  width: 100%;
  /*border: 1px solid red;*/
  margin-bottom: 30px;
  /*background: #eee;*/
}

/*header*/
.current-chords {
  justify-content: space-between;
}

.hold {
  width: 100%;
  transition: all 1s ease-in-out;
}
</style>
